module.exports = __webpack_public_path__ + "img/logo2.805a12af.png";